import './App.css';
import React from 'react';
import { NavLink } from 'react-router-dom';

const RequestSubmitted = () => {
  return (
    <div className="centered-content">
      <h2 className="title">Request Submitted ✅</h2>
      <h2 className="general-text">More VCE, site walks, PTO, etc in your immediate future?</h2>
        <NavLink to="/request-coverage" className="button-link">
            <div className="button-text">Submit another request →</div>
        </NavLink>
    </div>
  );
};

export default RequestSubmitted;